export function faq() {
    $(".faq-list dt").on("click", e => {
        e.preventDefault();
        $(e.target).next().slideToggle();
    })
}